const mutations = {
    setUsers: (state, payload) => {
        state.users = payload;
    },
    setUserForm: (state, payload) => {
        state.user = payload;
    },
    setUserPerfil: (state, payload) => {
        state.userPerfil[0].checked = false
        state.userPerfil[1].checked = false
        state.userPerfil[payload.index].checked = payload.checked;
    
    },
    setUserNameForm: (state, payload) => {
        state.user.firstName = payload;
    },
    setUserLastNameForm: (state, payload) => {
        state.user.lastName = payload;
    },
    setUserPhoneForm: (state, payload) => {
        state.user.phone = payload;
    },

    setUserCpfForm: (state, payload) => {
        state.user.cpf = payload;
    },
    setUserCnpjForm: (state, payload) => {
        state.user.cnpj = payload;
    },
    setUserCorporateNameForm: (state, payload) => {
        state.user.corporateName = payload;
    },
    setUserFantasyNameForm: (state, payload) => {
        state.user.fantasyName = payload;
    },

    setUserEmailForm: (state, payload) => {
        state.user.email = payload;
    },
    setUserPerfilForm: (state, payload) => {
        state.user.role = payload;
    },
    setUserStatusForm: (state, payload) => {
        state.user.eneble = payload;
    },
    setUserStatus: (state, payload) => {
        state.user.status = payload;
    },
    setApisConsumed: (state, payload) => {
        state.apisConsumed = payload;
    },
    setBackupUser: (state, payload) => {
        state.backupUser = payload;
    },
    

};

export default mutations;
